import classNames from "classnames"
import type { FunctionComponentElement } from "react"

import {
  Children,
  useMemo,
} from "react"

import styles from "./PopoverMenu.module.scss"
import { useCloneElement } from "src/hooks"

export interface Props {
  children?: FunctionComponentElement<SVGElement>;
}

export function PopoverMenuItemIcon(props: Props) {
  const { children } = props

  const child = Children.only<FunctionComponentElement<SVGElement>>(children || <svg />)

  const svgProps = useMemo(
    () => ({
      className: classNames(
        styles.popoverMenuItemIcon,
      ),
    }),
    [],
  )

  return useCloneElement<SVGElement>(
    child,
    svgProps,
  )
}
